import { Component } from 'react';
import { connect } from 'react-redux';
import { pushMessageReceived } from '../../state/push/Push.actions';
import loadScript from 'load-script';
import Constants from '../../constants/Constants';
import { logToAppInsights } from '../../utils/AppInsights';
import { getAccessTokenAsync } from '../../helpers/Helpers';

class SignalRBootstrapper extends Component {
  constructor() {
    super();
    this._ensureSignalRIsConnected = this._ensureSignalRIsConnected.bind(this);
  }

  componentDidMount() {
    this._ensureJQueryIsLoaded()
      .then(this._ensureSignalRScriptIsLoaded)
      .then(this._ensureSignalRScriptProxyIsLoaded)
      .then(this._ensureSignalRIsConnected)
      .catch((err) => {
        console.log(err);
        logToAppInsights('SignalR', err, 'error');
      });
  }

  render() {
    return null;
  }

  _ensureJQueryIsLoaded() {
    return new Promise((resolve, reject) => {
      if (window.jQuery) {
        resolve();
        return;
      }

      //try with local files
      loadScript(Constants.JQUERY_URL, (err) => {
        if (err) {
          reject('Could not load jQuery');
        } else {
          resolve();
        }
      });
    });
  }

  _ensureSignalRScriptIsLoaded() {
    return new Promise((resolve, reject) => {
      if (window.jQuery.signalR) {
        resolve();
        return;
      }

      //try with local files
      loadScript(Constants.SIGNALR_SCRIPT_URL, (err) => {
        if (err) {
          reject('Could not load SignalR script');
        } else {
          resolve();
        }
      });
    });
  }

  _ensureSignalRScriptProxyIsLoaded() {
    return new Promise((resolve, reject) => {
      if (window.jQuery.signalR.hub && window.jQuery.signalR.hub.url) {
        resolve();
        return;
      }

      loadScript(Constants.SIGNALR_PROXYSCRIPT_URL, (err) => {
        if (err) {
          reject('Could not load SignalR hubs proxy script');
        } else {
          resolve();
        }
      });
    });
  }

  _ensureSignalRIsConnected() {
    return new Promise((resolve, reject) => {
      const signalR = window.jQuery.connection;
      const hub = signalR.hub;

      if (hub.state !== window.jQuery.signalR.connectionState.disconnected) {
        resolve();
        return;
      }

      hub.url = Constants.SIGNALR;

      let connect = () => {
        getAccessTokenAsync(true).then((result) => {
          let accessTokenHeader = null;
          if (result != null) {
            accessTokenHeader = { access_token: result.accessToken };
          }
          hub.qs = accessTokenHeader;

          signalR.notificationsHub.client.pushMessage = (message) =>
            this.props._storePushMessage(message);

          hub.start().done(function () {
            console.log('Connected to SignalR Hub!');
            resolve();
          });
        });
      };

      hub.disconnected(function () {
        console.log('Connection to SignalR Hub disconnected, retrying in 5 seconds...');
        setTimeout(function () {
          connect();
        }, 5000); // Restart connection after 5 seconds.
        if (hub.lastError) {
          logToAppInsights(
            'SignalR',
            'SignalR Disconnected. Reason: ' + hub.lastError.message,
            'error'
          );
        }
      });

      connect();
    });
  }
}

const mapStateToProps = (state) => ({
  push: state.push,
});

const mapDispatchToProps = (dispatch, props) => ({
  _storePushMessage: (data) => {
    return dispatch(pushMessageReceived(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SignalRBootstrapper);
